import { render } from "./DesignMethodPage.vue?vue&type=template&id=e69d7bc0&scoped=true"
import script from "./DesignMethodPage.vue?vue&type=script&lang=js"
export * from "./DesignMethodPage.vue?vue&type=script&lang=js"

import "./DesignMethodPage.vue?vue&type=style&index=0&id=e69d7bc0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e69d7bc0"]])

export default __exports__